import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { FadeLoader } from "react-spinners";
import { ToastContainer } from "react-toastify";
import { setAccessToken } from "../redux/featuresSlice/commonSlice";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.3)",
  zIndex: 9999,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const Layout = () => {
  const statusLoading = useSelector((state) => state.common.statusLoading);
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    const token =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");
    if (token) {
      dispatch(setAccessToken(token));
    }
  }, [dispatch]);
  useEffect(() => {
    if (i18n.language !== "en") {
      i18n.changeLanguage("en");
    }
  }, [i18n]);
  return (
    <>
      {statusLoading && (
        <div style={overlayStyle}>
          <FadeLoader color="#3534ff" />
        </div>
      )}
      <Outlet />
      <ToastContainer
        position="top-center"
        closeButton={false}
        hideProgressBar
        newestOnTop
        icon={false}
        toastClassName={() => "p-0 bg-transparent shadow-none"}
        bodyClassName={() => "p-0 bg-transparent"}
        autoClose={3000}
      />
    </>
  );
};

export default Layout;
